/* eslint-disable react/jsx-no-bind */
import { Radio } from "@bluframe/blublocks"
import Button from "components/buttons/Button"

import { ComponentProps } from "."
import { ButtonGroup, ListItem } from "./styled"

const Item = ({
  flagLoading,
  id,
  isFlagged,
  isShowFlagButton,
  label,
  name,
  onSelect,
  onToggleFlagged,
  selected,
  url
}: ComponentProps) => {
  const onInspectClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    window.open(url, "__blank")
  }

  return (
    <ListItem aria-label={label}>
      <Radio
        inputId={id}
        isChecked={selected === id}
        label={label}
        name={name}
        onChange={onSelect}
        value={id}
      />

      <ButtonGroup aria-label="Actions" role="group">
        <Button label="Inspect" noPadding onClick={onInspectClick} outlined />

        {isShowFlagButton ? (
          <Button
            label={isFlagged ? "Unflag" : "Flag"}
            loading={flagLoading}
            onClick={onToggleFlagged(id, isFlagged)}
            outlined
          />
        ) : null}
      </ButtonGroup>
    </ListItem>
  )
}

export default Item
